import { render, staticRenderFns } from "./HistoryChat.vue?vue&type=template&id=7c564420&scoped=true&lang=pug&"
import script from "./HistoryChat.vue?vue&type=script&lang=ts&"
export * from "./HistoryChat.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryChat.vue?vue&type=style&index=0&id=7c564420&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c564420",
  null
  
)

export default component.exports